function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.23008,3.31281a2,2,0,1,0,0,2.82843A2,2,0,0,0,12.23008,3.31281ZM9.87415,7.57608A3.00613,3.00613,0,0,1,7.96682,5.66874l-.38668.49654L8.02987,7.513l1.347.449ZM8.428,8.70026l-1.18937-.396L6.84193,7.11422l-2.7853,3.5815.78984.78983Zm4.50921-6.09455A3.00039,3.00039,0,0,1,11.38,7.67381L9.611,9.04745l-.01387.043L9.56853,9.08,4.764,12.81731l-.665-.66637-.915.915.00008,1.207h-1V12.65165L3.392,11.44383l-.66637-.665L6.46221,5.97366,6.45244,5.9458l.0423-.01457L7.86908,4.16292A2.98353,2.98353,0,0,1,8.5735,2.734l.12105-.12824A3,3,0,0,1,12.93718,2.60571Z"
});

var SvgEvent = function SvgEvent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/event.9f540cc9.svg";
export { ForwardRef as ReactComponent };